import React from 'react';

export const ActionsContext = React.createContext({
  reload: '',
  reloadAll: () => { },
});

export default ActionsContext;
